// @flow
import React, { Component } from 'react'

export default class Home extends Component {
  render () {
    return (
      <div>
        <h1>Hola wink ;)</h1>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/index.js